import { render, staticRenderFns } from "./GameTrendChartMobile.vue?vue&type=template&id=a9ed1db0&scoped=true"
import script from "./GameTrendChartMobile.vue?vue&type=script&lang=js"
export * from "./GameTrendChartMobile.vue?vue&type=script&lang=js"
import style0 from "./GameTrendChartMobile.vue?vue&type=style&index=0&id=a9ed1db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ed1db0",
  null
  
)

export default component.exports